import { render } from "./MyLeaveWidget.vue?vue&type=template&id=dd72c298&scoped=true"
import script from "./MyLeaveWidget.vue?vue&type=script&lang=js"
export * from "./MyLeaveWidget.vue?vue&type=script&lang=js"

import "./MyLeaveWidget.vue?vue&type=style&index=0&id=dd72c298&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd72c298"]])

export default __exports__